// read app config
let appConfig = {
  state: {},
  i18n: {},
  projects: null
}

const configEl = document.getElementById('config')

if (configEl) {
  let config = configEl.innerHTML

  // is it encrypted ?
  if (process.env.ENCRYPT_APP_CONFIG === true) {
    // TODO
  }

  // is it base64_encoded ?
  if (process.env.ENCODE_APP_CONFIG === true) {
    config = atob(config)
  }

  try {
    appConfig = JSON.parse(config)

    // append projects loaded to state
    if (appConfig && appConfig.projects && appConfig.projects.length) {
      appConfig.state.apiData = appConfig.projects
    }
  } catch (error) {
    console.warn('Application configuration could not be read!')
  }
}

export { appConfig }



// WEBPACK FOOTER //
// ./src/store/config.js